import { getLocalizedPath } from "@/lib/i18nRoutes";

export function marinaSlug(marina = {}) {
  return String(marina.slug || marina.name || "marina")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "") || "marina";
}

export function marinaCountrySlug(marina = {}) {
  return String(marina.country || marina.location || "world")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "") || "world";
}

export function marinaDetailPath(marina = {}, langOrPrefix = "en") {
  const lang = String(langOrPrefix || "en").replace(/^\/+/, "").split("/")[0] || "en";
  const localizedBase = getLocalizedPath("marinas", lang);
  const base = localizedBase && localizedBase !== "/404" ? localizedBase : `/${lang}/marinas`;
  return `${base}/${marinaCountrySlug(marina)}/${marinaSlug(marina)}`;
}